import { convertToFormData } from "shared-services";

import { constructAuthPath } from "../helpers/fetch-request";
import { IAuthParams } from "./user-account-service.types";
import { IUploadHeadshotRequest } from "./webmedia-service.types";

export class WebMediaService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  async uploadHeadshot(
    params: IUploadHeadshotRequest,
    authParams: IAuthParams
  ) {
    return fetch(
      constructAuthPath(`${this.url}/new_joiners_photo.aspx`, authParams),
      {
        method: "POST",
        body: convertToFormData(params),
        headers: {
          accept: "application/text",
        },
      }
    );
  }
}
